import React from "react";

export const startModal = () => ({
  title: "Welcome to Guess the Country!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">Think you know the world?</div>
      <div className="modal-description-contents">
        <p>
          You’ll get clues like the continent, capital, and currency. You have{" "}
          <strong>2 guesses</strong> to figure out the country.
        </p>
        <p>
          Need a hand? You can reveal the flag — but it'll cost you{" "}
          <strong>200 points</strong>. Get it right and earn{" "}
          <strong>500 points</strong> per correct guess.
        </p>
      </div>
      <div className="modal-description-footer">
        Can you score a perfect 2500 across all 5 questions?
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const resultModal = (correct, answer, isLast, flagUrl) => ({
  title: correct ? "Correct!" : "Out of Guesses",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          {correct
            ? `Nice work! The answer was ${answer}.`
            : `Too bad! The correct answer was ${answer}.`}
        </p>
        <br />
        <img
          src={flagUrl}
          alt={`Flag of ${answer}`}
          className="modal-description-flag"
        />
      </div>
    </div>
  ),
  buttonText: isLast ? "Finish" : "Next",
  buttonType: "start",
});

export const finalModal = (score) => ({
  title: "Game Over",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title" />
      <div className="modal-description-contents">
        <p>
          You finished with a total score of <strong>{score}</strong> points.
        </p>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});
